import React from 'react';
import { connect } from 'react-redux';
import { updateScroll } from 'redux-first-router';

import { selectLocation } from '../../store/location/selectors';

class ScrollContext extends React.Component {
  componentDidUpdate(prevProps) {
    if (prevProps.path !== this.props.path) {
      updateScroll();
    }
  }

  render() {
    return this.props.children;
  }
}

export default connect((state) => ({
  path: selectLocation(state).pathname,
}))(ScrollContext);
